






































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconUpload,
    NextPrevBtn,
    Footer,
  },
})
export default class ReadHardened extends Vue {
   protected nxtprevReadHardened =
  {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail7.png",
    NextImage: " ",
    PrevLink: "/PlaisirdeLire/BandesDessinees",
    NextLink: " ",
  };
}
